document.addEventListener("DOMContentLoaded", function () {
  const headerOpenDrawer = document.querySelector("#open-cartDrawer");
  if (headerOpenDrawer) {
    headerOpenDrawer.addEventListener("click", function (e) {
      e.preventDefault();
      setTimeout(() => {
        document.querySelector("html").classList.add("js-ajax-cart-open");
        return false;
      }, 60);
    });
  }

  /**
   * The function `hideUpsellProduct` hides a specific upsell product element based on the provided
   * product ID.
   * @param e - The parameter `e` in the `hideUpsellProduct` function is used to specify the product ID
   * that you want to hide from the upsell products list.
   */
  function hideUpsellProduct(e) {
    let upsellProducts = document.querySelectorAll(".cart__upsells-products");
    upsellProducts.forEach((product) => {
      let productId = product.getAttribute("data-product-id");
      if (productId == e) {
        product.classList.add("hidden");
      }
    });
  }

  /**
   * The function `getCartData` fetches cart data from a specified endpoint and executes a callback
   * function with the retrieved data.
   * @param callback - The `callback` parameter in the `getCartData` function is a function that will
   * be called with the `cart` data retrieved from the `/cart.js` endpoint. It allows you to pass a
   * function as an argument to be executed once the cart data is successfully fetched.
   */
  function getCartData(callback) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (typeof callback === "function") callback(cart);
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
  }

  /**
   * The function `checkCartData` hides upsell products for items in the cart if there are any.
   */
  function checkCartData() {
    getCartData(function (cart) {
      setCartCount(cart);
      const items = cart.items;
      if (items.length > 0) {
        items.forEach((item) => {
          hideUpsellProduct(item.id);
        });
      }
    });
  }
  checkCartData();

  /**
   * The function `setCartCount` updates the text content of an element with the id 'cartCount' to
   * display the item count from a given cart object.
   * @param cart - The `cart` parameter is likely an object that contains information about the items
   * in the shopping cart, such as the item count.
   * @returns If the element with the id 'cartCount' does not exist in the document, the function will
   * return early and not set the cartCount text content.
   */
  function setCartCount (cart) {
    const cartCount = document.getElementById('cartCount');

    if (!cartCount) return;

    cartCount.textContent = cart.item_count;
  }

  liquidAjaxCart.conf("quantityTagAllowZero", true);
  liquidAjaxCart.conf("updateOnWindowFocus", false);


  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail;
    if (
      requestState.requestType === "add" ||
      (requestState.requestType === "change" && requestState.responseData?.ok)
    ) {
      document.querySelector("html").classList.add("js-ajax-cart-open");
      setTimeout(() => {
        checkCartData();
      }, 50);
    }
  });

  document.addEventListener("click", function (event) {
    const cartDrawer = document.getElementById("ajaxify-cart");
    const cartDrawerClose = document.getElementById("ajaxify-cart__close");
    if (
      !cartDrawer.contains(event.target) ||
      cartDrawerClose.contains(event.target)
    ) {
      document.querySelector("html").classList.remove("js-ajax-cart-open");
    }
  });


  document.body.addEventListener("click", function (e) {
    const button = e.target.closest(".upsells-form__submit");
    if (!button) return; 
    const variantId = button.getAttribute("data-variant-id-upsells");
    const hiddenText = button.querySelector(".upsells");
    const spinner = button.querySelector("[data-loader-upsells]");

    if (spinner && hiddenText) {
      spinner.classList.remove("hidden");
      hiddenText.classList.add("hidden");
      setTimeout(() => {
        spinner.classList.add("hidden");
        hiddenText.classList.remove("hidden");
      }, 2000);
    }

    if (variantId) {
      addToCartWithFeedback(variantId);
    }
  });

  /**
   * The function `addToCartWithFeedback` adds an item with a specified variant ID to the cart using
   * liquidAjaxCart.
   * @param variantId - The `variantId` parameter is the unique identifier for a specific product
   * variant that you want to add to the cart.
   */
  function addToCartWithFeedback(variantId) {
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1 
        }
      ]
    };
    liquidAjaxCart.add(formData);
  }
  
 
  /**
   * The function `updateFreeShipping` calculates the remaining amount needed to qualify for free
   * shipping based on the total cart value and minimum required amount.
   */
  function updateFreeShipping() {
    const free_shipping = document.querySelector(".free_shipping");

    if (free_shipping) {
      let amount_text = free_shipping.querySelector(
        ".free_shipping--text span"
      );
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(
        parseInt(free_shipping.dataset.minimum, 10) *
          (Shopify.currency.rate || 1)
      );
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format =
              window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }
      free_shipping.style.setProperty("--percentage", percentage);
    }
  }
  updateFreeShipping();
});